import { useContentful, getVariantContent } from '@pcln/contentful-components'
import { useFeature } from '@pcln/feature-components'
import useSeti from './useSeti'

function useContent(item: any, shouldFireImpression = true) {
  const setiName = useSeti(
    item?.experimentName,
    shouldFireImpression && item?.experimentName !== undefined
  )
  return item?.experimentName ? getVariantContent(setiName, item) : item
}

export default function useContentfulSearchFormHeadlines(
  name: string,
  shouldFireImpression = true
) {
  const searchFormResponse: any = useContentful(name)
  const searchForm = useContent(searchFormResponse, shouldFireImpression)
  const contentfulEnabled = useFeature('siteExperience.contentfulEnabled')
  const contentfulEnabledAndHasContent = contentfulEnabled && searchForm != null

  return contentfulEnabledAndHasContent ? searchForm : null
}
